import { DirectionFindDto, type DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import { BudgetRequestItemAnalyticsDto, type BudgetRequestItemAnalyticsInterface } from '@zaoblako/shared/modules/task/dtos/budget-request/item/budget-request-item-analytics.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';

import * as yup from 'yup';

/** Budget request item response body */
export interface BudgetRequestItemFindInterface {
  /** Related direction */
  direction: DirectionFindInterface;
  /** Amount value */
  amount: number;
  /** Child directions data */
  children?: BudgetRequestItemFindInterface[];
  /** Analytics for the previous three months for the this item */
  analytics?: BudgetRequestItemAnalyticsInterface;
}

/** Budget request item response body - DTO schema */
export const BudgetRequestItemFindDto = SerdeDtoClass.create<BudgetRequestItemFindInterface>(TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_FIND_DTO, {
  direction: {
    label: 'БС',
    nested: DirectionFindDto,
    serializer: (_, nested) => nested,
  },
  amount: {
    label: 'Сумма',
    serializer: yup.number(),
  },
  children: {
    optional: true,
    label: 'Дочерние БС',
    nested: TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
  analytics: {
    optional: true,
    label: 'Аналитика',
    nested: BudgetRequestItemAnalyticsDto,
    serializer: (_, nested) => nested,
  },
});
